export const SET_TABLE_PAGE = "SET_TABLE_PAGE";
export const SET_TABLE_ROWS_PER_PAGE = "SET_TABLE_ROWS_PER_PAGE";
export const SET_TABLE_ORDER = "SET_TABLE_ORDER";
export const SET_TABLE_ORDER_BY = "SET_TABLE_ORDER_BY";
export const SET_TABLE_SELECTED = "SET_TABLE_SELECTED";
export const SET_TABLE_SUBROW_SELECTED = "SET_TABLE_SUBROW_SELECTED";
